/**
 * Renders the light inline markup used in src/data/content.js:
 *   **bold**  ->  <b>
 *   *italic*  ->  <em>
 *
 * Deliberately tiny and non-recursive — it exists so copy can live in plain
 * data files without reaching for dangerouslySetInnerHTML.
 */
const TOKEN = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;

export default function RichText({ text }) {
  if (!text) return null;

  return (
    <>
      {text
        .split(TOKEN)
        .filter(Boolean)
        .map((part, i) => {
          if (part.startsWith('**') && part.endsWith('**')) return <b key={i}>{part.slice(2, -2)}</b>;
          if (part.startsWith('*') && part.endsWith('*')) return <em key={i}>{part.slice(1, -1)}</em>;
          return part;
        })}
    </>
  );
}
